import { NgFor, NgIf } from '@angular/common';
import { Component, Input, OnInit, CUSTOM_ELEMENTS_SCHEMA, ChangeDetectorRef } from '@angular/core';
import { RouterModule } from '@angular/router';
import { ImageModule } from 'primeng/image';

@Component({
  selector: 'app-gallery-project',
  standalone: true,
  imports: [NgFor, NgIf, RouterModule, ImageModule],
  templateUrl: './gallery-project.component.html',
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class GalleryProjectComponent implements OnInit {

  @Input()
  public data!: any;

  constructor(private _cdr: ChangeDetectorRef) {
  }

  ngOnInit(): void {
    this._cdr.detectChanges();
    
  }

  public getRamdonLink(list: any[]): string {
    let link: string = '';

    const randomNumber = Math.floor(Math.random() * list.length);

    if (randomNumber > 0) {
      link = list[randomNumber];
    }

    return link;
  }

  public scrollToFeatureSection(): any {
    const element = document.getElementById(this.data.slug + '-feature-section');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  }

  public scrollToSection(id: string): any {
    const element   = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  }
}
